import { TReducerRootState } from './types';

export const selectorIsLoggedIn = (state: TReducerRootState) =>
    state.app.isLoggedIn;
export const selectorCurrentSessionTitle = (state: TReducerRootState) =>
    state.app.currentSessionData;
export const selectorAppBarTitle = (state: TReducerRootState) =>
    state?.appBar?.title;
export const selectorPermissions = (state: TReducerRootState) =>
    state.app.currentSessionData.permissions;
